// extracted by mini-css-extract-plugin
export default {"support":"SupportAndHelp_support__Vu9O1"};